module.exports = __webpack_public_path__ + "img/routeleaf-logo-text-white.2dc25359.svg";